import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Club() { 
  useEffect(() => {
    document.title = 'Club-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Club</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Club</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                   <p>The School offers various clubs for the students.  The club activities provide ample opportunities to the students to engage themselves in a wide variety of co-curricular activities.</p>
               <ul className="mainlist">
                    <li>    Science & Eco Club </li>
                    <li>    Peace & Kindness Club </li>
                    <li>    Health & Wellness Club </li>
                    <li>    Heritage Club </li>
                    <li>    Literary Club </li>
               </ul> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Club;
